<template>
  <section class="program-tv">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h3 class="program-tv__title">Program TV</h3>
        </div>
      </div>
    </div>
  </section>
  <section class="program-tv__content">
    <div class="container">
      <div class="columns">
        <div class="column">
          <ProgramTvFilter 
            :hoursArray="hoursArray"
            @updateDay="newDate" 
            @updateTime="newTime" 
          />
        </div>
      </div>
      <div class="columns" v-for="(item, index) in itemsToShow()" :key="index">
        <div class="column">
          <ProgramTvItem
            :isLive="item?.live"
            :isContinue="isCurrent(item.date_start, item.date_end)"
            :isSign="item?.jm"
            :isSubbed="item?.nt"
            :programContext="item"
            :programProgress="getProgramProgress(item.date_start, item.date_end)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watch } from 'vue'
import ProgramTvFilter from '@/components/program/ProgramTvFilter.vue'
import ProgramTvItem from '@/components/program/ProgramTvItem.vue'
import { useProgramsStore } from '@/stores/programs'
import { storeToRefs } from 'pinia'

const programs = useProgramsStore()
const { programsList, programsItems } = storeToRefs(programs)
const { fetchProgramsList } = programs

const stationCode = ref('INF')
const hoursArray = ref()
const timelineTime = ref({ hour: 'current', flag: 0 })
const programDate = ref()

const newDate = (date) => {
  fetchProgramsList(stationCode.value, date).then(() => {
    if (programsList.value) {
        programDate.value = date
        hoursArray.value = getHoursList(programsList.value[0]?.date_start, programsList.value[programsList.value.length - 1]?.date_end)
    }
  })
}

const newTime = (time) => {
  timelineTime.value = time
}

const getHoursList = (firstProgram, lastProgram) => {
    if (firstProgram && lastProgram) {
        const list = [
          { id: 0, title: 'Teraz', hour: 'current', flag: 0 },
          { id: 1, title: 'Rano', hour: '7:00', flag: 0 },
          { id: 2, title: 'Południe', hour: '12:00', flag: 0 },
          { id: 3, title: 'Wieczór', hour: '20:00', flag: 0 }
        ];
        const start = new Date(firstProgram);
        const end = new Date(lastProgram);
        let index = 5;
        const flagStart = start.getDate();

        while (start <= end) {
            list.push({
                id: index++,
                time: '',
                hour: `${start.getHours()}:00`,
                title: `${start.getHours()}:00`,
                flag: flagStart === start.getDate() ? 0 : 1
            });
            start.setHours(start.getHours() + 1, 0, 0);
        }
        return list;
    }
    return [];
}

const getProgramProgress = (start, end) => {
    if (start) {
        const duration = getProgramDuration(start, end);
        const currentTime = new Date().getTime();
        const startD = new Date(start);
        const progress = Math.abs(
            Math.round((currentTime - startD) / 1000 / 60)
        );
        const progressPercent =
            progress / duration === 0 ? 1 : (progress / duration) * 100;

        return `${progressPercent}`;
    }
    return '';
}

const getProgramDuration = (start, end) => {
    if (start && end) {
        const startD = new Date(start);
        const endD = new Date(end);
        const duration = Math.abs(
            Math.round((endD - startD) / 1000 / 60)
        );
        return duration;
    }
    return 10; // default value
}

const programTime = () => {
    if (programDate.value) {
        const progDate = programDate.value.split('-');
        const year = progDate[0];
        const month = progDate[1] - 1;
        const day = progDate[2];
        let hour = 0;

        if (timelineTime.value.hour !== 'current') {
            hour = timelineTime.value.hour.split(':')[0];

            if (timelineTime.value.flag === 1) {
                const date = new Date(programDate.value);

                date.setDate(date.getDate() + 1);
                date.setHours(hour, 0, 0);
                return new Date(date);
            }
            return new Date(year, month, day, hour);
        }
        return new Date(year, month, day, hour);
    }
    return null;
}

const isCurrent = (start, end) => {
    const currentTime = new Date().getTime();
    if (currentTime > start && currentTime < end) {
        return true;
    }
    return false;
}

const isProgramDateToday = () => {
    if (programDate.value) {
        const today = new Date();
        const date = new Date(programDate.value);
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    }
    return true;
}

const dateFromHour = () => {
    let { hour } = timelineTime.value;
    const { flag } = timelineTime.value;
    const date = new Date();

    if (flag === 0) {
        hour = hour.split(':')[0];
        date.setHours(hour, 0, 0);
        return new Date(date);
    }
    if (flag === 1) {
        hour = hour.split(':')[0];
        date.setDate(date.getDate() + 1);
        date.setHours(hour, 0, 0);
        return new Date(date);
    }
    return null;
}

const itemsToShow = () => {
    if (programsList.value) {
        let date = null;

        if (isProgramDateToday()) {
            if (timelineTime.value.hour === 'current') {
                date = new Date();
            } else {
                date = dateFromHour();
            }
        } else {
            date = programTime();
        }

        return programsList.value?.filter((item) => {
            return item.date_end > date.getTime();
        });
    }
    return null;
}

onMounted(() => {
  fetchProgramsList(stationCode.value).then(() => {
    if (programsList.value) {
        hoursArray.value = getHoursList(programsList.value[0]?.date_start, programsList.value[programsList.value.length - 1]?.date_end)
    }
  })
})
</script>

<style lang="scss">
@import '@/assets/scss/views/program-tv-page.scss';
</style>
